'use strict';

angular.module('shiftTraderApp')
  .service('WeekCalculationService', ['UserPermissionsService', function (UserPermissionsService) {
    var useActualWage = undefined;
    var permissionsToLookUp = [
      'users.view_actual_employee_wages',
      'users.view_estimated_labor_cost'
    ];

    var calcWeekWorkPeriodStats = function(dayStartDates, wpOverlapsByDay, departments, org) {
      var dayAnalysisDataByDay = [];

      function finishTask(wp, isAssigned, deptId, startsDuringDay, isPublished, lengthOfShiftInHours, td) {
        // is assigned
        if (isAssigned) {

          var laborCost;
          if (useActualWage) {
            laborCost = wp.hourly_wage * lengthOfShiftInHours;
          } else {
            laborCost = org.organization_config.hourly_rate_for_estimates * lengthOfShiftInHours;
          }
          // console.log('MATT', laborCost, wp, lengthOfShiftInHours)
          //add up labor cost
          td.laborCost += laborCost;

          td.departmentData[deptId].laborCost += laborCost;

          td.totalAssignedLaborHours += lengthOfShiftInHours;
          td.departmentData[deptId].totalAssignedLaborHours += lengthOfShiftInHours;

          // figure out user_id
          td.uniqueEmployeesWorking.push(wp.user_id);
          td.departmentData[deptId].uniqueEmployeesWorking.push(wp.user_id);

          // add up all assigned workPeriods that intersect and that started today
          td.numAssignedWorkPeriods += 1;
          td.departmentData[deptId].numAssignedWorkPeriods += 1;

          if (startsDuringDay) {
            td.numAssignedWorkPeriodsStartingToday += 1;
            td.departmentData[deptId].numAssignedWorkPeriodsStartingToday += 1;
          }

          if (isPublished) {
            // is assigned AND is published

            // add up labor hours
            td.assignedPublishedLaborHours += lengthOfShiftInHours;
            td.departmentData[deptId].assignedPublishedLaborHours += lengthOfShiftInHours;

            // push wpId onto correct category
            td.assignedPublishedWorkPeriods.push(wp.id);
            td.departmentData[deptId].assignedPublishedWorkPeriods.push(wp.id);

            if (startsDuringDay) {
              td.assignedPublishedWorkPeriodsStartingToday.push(wp.id);
              td.departmentData[deptId].assignedPublishedWorkPeriodsStartingToday.push(wp.id);
            }
          } else {
            // is assigned AND is NOT published

            // add up labor hours
            td.assignedUnpublishedLaborHours += lengthOfShiftInHours;
            td.departmentData[deptId].assignedUnpublishedLaborHours += lengthOfShiftInHours;

            // push wpId onto correct category
            td.assignedUnpublishedWorkPeriods.push(wp.id);
            td.departmentData[deptId].assignedUnpublishedWorkPeriods.push(wp.id);

            if (startsDuringDay) {
              td.assignedUnpublishedWorkPeriodsStartingToday.push(wp.id);
              td.departmentData[deptId].assignedUnpublishedWorkPeriodsStartingToday.push(wp.id);
            }
          }
        } else {
          // not assigned
          // going to assume not published also
          var laborCost = org.organization_config.hourly_rate_for_estimates * lengthOfShiftInHours;
          td.laborCost += laborCost;
          td.departmentData[deptId].laborCost += laborCost;

          // add up labor hours
          td.unassignedLaborHours += lengthOfShiftInHours;
          td.departmentData[deptId].unassignedLaborHours += lengthOfShiftInHours;

          // push wpId onto correct category
          td.unassignedUnpublishedWorkPeriods.push(wp.id);
          td.departmentData[deptId].unassignedUnpublishedWorkPeriods.push(wp.id);

          if (startsDuringDay) {
            td.unassignedUnpublishedWorkPeriodsStartingToday.push(wp.id);
            td.departmentData[deptId].unassignedUnpublishedWorkPeriodsStartingToday.push(wp.id);
          }
        }

        // total of all labor hours!
        td.totalLaborHours += lengthOfShiftInHours;
        td.departmentData[deptId].totalLaborHours += lengthOfShiftInHours;

        // add up all workPeriods that intersect and that started today
        td.numTotalWorkPeriods += 1;
        td.departmentData[deptId].numTotalWorkPeriods += 1;

        if (startsDuringDay) {
          td.numTotalWorkPeriodsStartingToday += 1;
          td.departmentData[deptId].numTotalWorkPeriodsStartingToday += 1;
        }
      }

      _.each(dayStartDates, function(dt, idx) {
        var currTwix = dt.twix(moment(dt).add(1, 'days'));

        //OPTIMIZATION: can possibly cache "currTwix.contains(wp.start_time) && !currTwix.end.isSame(wp.start_time)" for each WP

        var td = {
          publishData: {
            dayPublished: _.any(wpOverlapsByDay[idx], function (wp) {
              return wp.active && wp.$isAssigned() && wp.$isPublished() &&
                currTwix.contains(wp.start_time) && !currTwix.end.isSame(wp.start_time);
            }),
            dayNotAllPublished: _.any(wpOverlapsByDay[idx], function (wp) {
              // if a workPeriod is active and it has not been published
              return wp.active && wp.$isAssigned() && !wp.$isPublished() &&
                currTwix.contains(wp.start_time) && !currTwix.end.isSame(wp.start_time);
            }),
            dayHasUnassigned: _.any(wpOverlapsByDay[idx], function (wp) {
              // if a workPeriod is active and it has not been published
              return wp.active && !wp.$isAssigned() &&
                currTwix.contains(wp.start_time) && !currTwix.end.isSame(wp.start_time);
            }),
            dayHasShifts: _.any(wpOverlapsByDay[idx], function (wp) {
              return wp.active && wp.$isAssigned() &&
                currTwix.contains(wp.start_time) && !currTwix.end.isSame(wp.start_time);
            })
          },

          laborCost: 0,                             // labor cost of all assigned WPs
          unassignedLaborHours: 0,                  // number of unassigned & not published labor hours that intersect this day
          assignedUnpublishedLaborHours: 0,         // number of assigned, unpublished labor hours that intersect this day
          assignedPublishedLaborHours: 0,           // number of published labor hours that intersect this day
          totalAssignedLaborHours: 0,               // number of (published & unpublished) assigned labor hours that intersect this day
          totalLaborHours: 0,                       // number of labor hours that intersect this day (

          // unassigned unpublished
          // assigned unpublished
          // assigned published

          // THEN:
          //  1) for WP that starts during this day
          //  2) for WP that intersects this day (inclusive of 1)

          // THEN:
          //  a) all above in num____
          //  b) all above as arrays of WP ids


          numUnassignedUnpublishedWorkPeriods: 0,               // number of unassigned unpublished WPs that intersect this day
          numAssignedUnpublishedWorkPeriods: 0,                 // number of assigned unpublished WPs that intersect this day
          numAssignedPublishedWorkPeriods: 0,                   // number of assigned published WPs that intersect this day

          numUnassignedUnpublishedWorkPeriodsStartingToday: 0,  // number of unassigned unpublished WPs that start during this day
          numAssignedUnpublishedWorkPeriodsStartingToday: 0,    // number of assigned unpublished WPs that start during this day
          numAssignedPublishedWorkPeriodsStartingToday: 0,      // number of assigned published WPs that start during this day

          unassignedUnpublishedWorkPeriods: [],                 // unassigned unpublished WP ids that intersect this day
          assignedUnpublishedWorkPeriods: [],                   // assigned unpublished WP ids that intersect this day
          assignedPublishedWorkPeriods: [],                     // assigned published WP ids that intersect this day

          unassignedUnpublishedWorkPeriodsStartingToday: [],    // unassigned unpublished WP ids that start during this day
          assignedUnpublishedWorkPeriodsStartingToday: [],      // assigned unpublished WP ids that start during this day
          assignedPublishedWorkPeriodsStartingToday: [],        // assigned published WP ids that start during this day

          numAssignedWorkPeriods: 0,                // number of assigned WPs that intersect today (published and unpublished)
          numAssignedWorkPeriodsStartingToday: 0,   // number of assigned WPS that start day (published and unpublished)
          numTotalWorkPeriods: 0,                   // number of WPs that intersect this day
          numTotalWorkPeriodsStartingToday: 0,      // number of WPs that start during this day
          uniqueEmployeesWorking: [],               // unique array of user_id's working (not guaranteed before function return)
          numUniqueEmployeesWorking: 0,             // length of above array
          dateTwix: currTwix,
          departmentData: (function () {
            var x = {};
            _.each(departments, function (dept) {
              x[dept.id] = {
                department_id: dept.id,
                laborCost: 0,                             // labor cost of all assigned WPs
                unassignedLaborHours: 0,                  // number of unassigned & not published labor hours that intersect this day
                assignedUnpublishedLaborHours: 0,         // number of assigned, unpublished labor hours that intersect this day
                assignedPublishedLaborHours: 0,           // number of published labor hours that intersect this day
                totalAssignedLaborHours: 0,               // number of (published & unpublished) assigned labor hours that intersect this day
                totalLaborHours: 0,                       // number of total (published, unpublished, unassigned or assigned) labor hours that intersect this day

                numUnassignedUnpublishedWorkPeriods: 0,               // number of unassigned unpublished WPs that intersect this day
                numAssignedUnpublishedWorkPeriods: 0,                 // number of assigned unpublished WPs that intersect this day
                numAssignedPublishedWorkPeriods: 0,                   // number of assigned published WPs that intersect this day

                numUnassignedUnpublishedWorkPeriodsStartingToday: 0,  // number of unassigned unpublished WPs that start during this day
                numAssignedUnpublishedWorkPeriodsStartingToday: 0,    // number of assigned unpublished WPs that start during this day
                numAssignedPublishedWorkPeriodsStartingToday: 0,      // number of assigned published WPs that start during this day

                unassignedUnpublishedWorkPeriods: [],                 // unassigned unpublished WP ids that intersect this day
                assignedUnpublishedWorkPeriods: [],                   // assigned unpublished WP ids that intersect this day
                assignedPublishedWorkPeriods: [],                     // assigned published WP ids that intersect this day

                unassignedUnpublishedWorkPeriodsStartingToday: [],    // unassigned unpublished WP ids that start during this day
                assignedUnpublishedWorkPeriodsStartingToday: [],      // assigned unpublished WP ids that start during this day
                assignedPublishedWorkPeriodsStartingToday: [],        // assigned published WP ids that start during this day

                numAssignedWorkPeriods: 0,                // number of assigned WPs that intersect today (published and unpublished)
                numAssignedWorkPeriodsStartingToday: 0,   // number of assigned WPS that start day (published and unpublished)
                numTotalWorkPeriods: 0,                   // number of WPs that intersect this day
                numTotalWorkPeriodsStartingToday: 0,      // number of WPs that start during this day
                uniqueEmployeesWorking: [],               // unique array of user_id's working (not guaranteed before function return)
                numUniqueEmployeesWorking: 0              // length of above array
              };
            });
            return x;
          })()
        };

        // for each dt return the hourly_wage * length of shift that overlaps with <dt, dt+24hr>
        // need to loop over shifts with start_times of dt-24hr -> dt+24
        var lengthOfShiftInHours, startsDuringDay, isPublished, isAssigned, laborCost, deptId;

        _.each(wpOverlapsByDay[idx], function(wp) {
          if (wp.active && wp.range_twix.overlaps(currTwix)) {
            startsDuringDay = currTwix.contains(wp.start_time) && !currTwix.end.isSame(wp.start_time);
            isPublished = wp.$isPublished();
            isAssigned = wp.$isAssigned();
            deptId = wp.position.department_id;

            lengthOfShiftInHours = wp.range_twix.intersection(currTwix).length('minutes') / 60.0;

            if (_.isUndefined(td.departmentData[deptId])) {
              Rollbar.warning('Orphaned position due to department deletion', {work_period_id: wp.id, position_id: wp.position.id, department_id: deptId});
              return; // don't process this workPeriod in there
            }

            if (useActualWage === undefined) {
              UserPermissionsService.getCanDict(permissionsToLookUp, org.id)
              .then(function(dikt) {
                if (dikt['users.view_actual_employee_wages']) {
                  useActualWage = true;
                } else {
                  useActualWage = false;
                }

                finishTask(wp, isAssigned, deptId, startsDuringDay, isPublished, lengthOfShiftInHours, td);
              });
            } else {
              finishTask(wp, isAssigned, deptId, startsDuringDay, isPublished, lengthOfShiftInHours, td);
            }

          }
        });

        // uniquize the uniqueEmployeesWorking arrays before taking length to create num_____
        _.each(departments, function(dept) {
          td.departmentData[dept.id].uniqueEmployeesWorking = _.unique(td.departmentData[dept.id].uniqueEmployeesWorking);
        });

        td.uniqueEmployeesWorking = _.unique(td.uniqueEmployeesWorking);

        _.each([
          ['numUnassignedUnpublishedWorkPeriods', 'unassignedUnpublishedWorkPeriods'],
          ['numAssignedUnpublishedWorkPeriods' ,'assignedUnpublishedWorkPeriods'],
          ['numAssignedPublishedWorkPeriods' ,'assignedPublishedWorkPeriods'],
          ['numUnassignedUnpublishedWorkPeriodsStartingToday' ,'unassignedUnpublishedWorkPeriodsStartingToday'],
          ['numAssignedUnpublishedWorkPeriodsStartingToday' ,'assignedUnpublishedWorkPeriodsStartingToday'],
          ['numAssignedPublishedWorkPeriodsStartingToday' ,'assignedPublishedWorkPeriodsStartingToday'],
          ['numUniqueEmployeesWorking', 'uniqueEmployeesWorking']
        ], function(arr) {
          _.each(departments, function(dept) {
            td.departmentData[dept.id][arr[0]] = td.departmentData[dept.id][arr[1]].length;
          });

          td[arr[0]] = td[arr[1]].length;
        });

        dayAnalysisDataByDay.push(td);
      });

      return dayAnalysisDataByDay;
    };

    return {
      calcWeekWorkPeriodStats: calcWeekWorkPeriodStats
    };

  }]);
